module.exports = __webpack_public_path__ + "nissco_mobile-app_bg.5fc7d4d9d65dffb16848.png";


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/assets/images/nissco_mobile-app_bg.png
// module id = ../../../../../src/assets/images/nissco_mobile-app_bg.png
// module chunks = 39